// extracted by mini-css-extract-plugin
module.exports = {"container":"dashboard_container__2MUVj","top":"dashboard_top__1EF9A"};